const env: ImportMetaEnv = import.meta.env;

export { env };
